import React from "react";
import { node, string } from "prop-types";
import Block from "@insightfulscience/atomic-react/Block";

import GoogleRecaptchaNotice from "./GoogleRecaptchaNotice";
import CastleNotice from "./CastleNotice";

const AnyCaptchaWrapper = ({ type, children }) => (
	<>
		{children}
		{!!type && (
			<Block spacing={{ mt: 10 }}>
				{type === "google-recaptcha" && <GoogleRecaptchaNotice />}
				{type === "castle" && <CastleNotice />}
			</Block>
		)}
	</>
);

AnyCaptchaWrapper.propTypes = {
	children: node.isRequired,
	type: string,
};

export default AnyCaptchaWrapper;
